import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPasswordView.css';
import TopBar from '../../common/TopBar/TopBar';
import AuthInput from '../../buttons/AuthInput';
import CTAButton from '../../buttons/CTAButton';
import { sendResetPasswordEmail } from '../../../api/auth';

const ForgotPasswordView: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [isResetting, setIsResetting] = useState(false);

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleResetPassword = async () => {
    if (isEmailValid && !isResetting) {
      setIsResetting(true);
      setError(null);
      try {
        await sendResetPasswordEmail(email);
        setSuccess(true);
      } catch (error) {
        setError('Failed to send reset password email. Please try again.');
        console.error('Reset password error:', error);
      } finally {
        setIsResetting(false);
      }
    }
  };

  if (success) {
    return (
      <div className="forgot-password-view">
        <TopBar showBackButton={true} />
        <h1 className="title">Email Sent</h1>
        <p className="description">
          If an account exists for {email}, you will receive an email with instructions to reset your password.
        </p>
        <CTAButton
          text="Back to Sign In"
          onClick={() => navigate('/signin')}
          isActive={true}
        />
      </div>
    );
  }

  return (
    <div className="forgot-password-view">
      <TopBar showBackButton={true} />
      <h1 className="title">Forgot Password</h1>
      <p className="description">Enter the email address associated with your account, and we'll email you a link to reset your password</p>
      <div className="input-container">
        <AuthInput
          type="email"
          placeholder="Write email"
          value={email}
          onChange={setEmail}
          isValid={isEmailValid}
        />
      </div>
      {error && <p className="error-message">{error}</p>}
      <CTAButton
        text={isResetting ? "Please wait..." : "Reset Password"}
        onClick={handleResetPassword}
        isActive={isEmailValid && !isResetting}
      />
    </div>
  );
};

export default ForgotPasswordView;